import React, { createContext, useContext, useEffect, useState } from "react";

// Bilingual scaffolding. Append entries freely as the site grows.
const TRANSLATIONS = {
  en: {
    brand: "Think Spanish",
    school: "School",
    immersion: "Immersion",
    students: "Students",
    teachers: "Teachers",
    partnerships: "Partnerships",
    backHome: "Back",
    contact: "Contact",
  },
  es: {
    brand: "Think Spanish",
    school: "Escuela",
    immersion: "Inmersión",
    students: "Estudiantes",
    teachers: "Profesores",
    partnerships: "Alianzas",
    backHome: "Volver",
    contact: "Contacto",
  },
};

const LangCtx = createContext({
  lang: "en",
  setLang: () => {},
  toggle: () => {},
  t: (k) => k,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem("lang");
    return saved === "es" ? "es" : "en";
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("lang", l);
    } catch {}
  };
  const toggle = () => setLang(lang === "en" ? "es" : "en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key;

  return (
    <LangCtx.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useI18n = () => useContext(LangCtx);
